import { Gettable } from './ApiInterfaces'
import { ResponseError } from './ApiBase'

/**
 * リビジョンID取得
 */

export namespace ApiFetchRevision {
  export const name: string = 'ApiFetchRevision'

  export namespace Get {
    export const path: string = `${process.env.BASE_URL}/revision.json`

    export interface Request {
      query: {
        // none request parameter.
      }
    }

    export interface Response {
      revision: string
    }
  }

  // API本体
  export class Api implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public async get<R>(): Promise<R | null> {
      try {
        const s3Revision = await fetch(Get.path, { cache: 'no-store' })
        if (!s3Revision.ok) {
          throw new Error(`HTTP error! status: ${s3Revision.status}`)
        }
        return await s3Revision.json()
      } catch (error) {
        // 失敗した場合は、nullを返す
        return null
      }
    }
  }
}
